import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { convertInputBufferToString } from 'ui-components/services/hotkey-service/convert-input-buffer-to-string';
import { Hotkey } from 'ui-components/components/hotkey';
import { SCAN_TO_VIEW } from '../constants/barcodes';

import { OrderSearchService } from '../../../services/order-search.service';

const messages = defineMessages({
  name: {
    description: 'modalHotkey.scanToView',
    defaultMessage: 'Scan To View',
    id: '4nkHOW',
  },
});

const ScanToViewHotkey = ({ children = null, onScanToView, isGlobal = false }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: SCAN_TO_VIEW,
      displayHotkeyStrings: [],
      doNotTrack: true,
      handler: (input) => {
        return onScanToView(convertInputBufferToString(input));
      },
      legacyCategory: 'general',
      matches: (str) => OrderSearchService.isThisAnOrderId(str),
      name: intl.formatMessage(messages.name),
      isGlobal,
    }),
    [intl, onScanToView, isGlobal],
  );

  return <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>;
};

ScanToViewHotkey.propTypes = {
  children: PropTypes.node,
  onScanToView: PropTypes.func.isRequired,
  isGlobal: PropTypes.bool,
};

export default ScanToViewHotkey;
